import { render } from "./DefaultSwiper.vue?vue&type=template&id=04d58a7c&scoped=true"
import script from "./DefaultSwiper.vue?vue&type=script&lang=js"
export * from "./DefaultSwiper.vue?vue&type=script&lang=js"

import "./DefaultSwiper.vue?vue&type=style&index=0&id=04d58a7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d58a7c"]])

export default __exports__